import { Component, inject } from '@angular/core';
import { DIALOG_DATA } from '@angular/cdk/dialog';
import { DialogCloseButtonComponent } from '@innersource/common-ui-components';
import { ToolJobResultsComponent } from './tool-job-results/tool-job-results.component';
import { Tool, ToolJob } from '../../../utils/models/tool.models';

export type JobDetailsContentType = 'results' | 'parameters';

export type JobDetailsDialData = {
  toolJob: ToolJob;
  tool: Tool;
  content: JobDetailsContentType;
};

@Component({
  selector: 'app-job-detail-dialog',
  templateUrl: './job-detail-dialog.component.html',
  styleUrls: ['./job-detail-dialog.component.scss'],
  imports: [DialogCloseButtonComponent, ToolJobResultsComponent],
})
export class JobDetailDialogComponent {
  /** State. */
  readonly data = inject<JobDetailsDialData>(DIALOG_DATA);
}
